export default "__VITE_ASSET__9c592bc8__"